import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"max-width":"80%"},model:{value:(_vm.getModalPrint.show),callback:function ($$v) {_vm.$set(_vm.getModalPrint, "show", $$v)},expression:"getModalPrint.show"}},[_c(VCard,{attrs:{"color":"#323639","dark":""}},[_c(VCardTitle,[_c(VSpacer),_c(VBtn,{attrs:{"icon":"","float-right":""},on:{"click":function($event){_vm.getModalPrint.show = false}}},[_c(VIcon,[_vm._v("mdi-close")])],1)],1),_c(VCardText,[_c('iframe',{staticStyle:{"border":"none"},attrs:{"src":_vm.getModalPrint.link,"width":"100%","height":"780"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }